import { Controller } from "@hotwired/stimulus";
import { renderMarkdown } from "../../markdown_renderer.js";

export default class extends Controller {
  connect() {
    const raw = this.element.textContent;
    this.element.innerHTML = renderMarkdown(raw);
  }
}
